<script setup>
// FLOW-06 (SPEC S5, R10; Task 6.1) — a seção Cofre da aba PowerFlow: o cofre da conta, que era a aba
// Segredos de Configurações › PowerTools, com o título. É o mesmo componente da sub-aba Segredos das
// Ferramentas de todo agente (lá, sem título).
import SegredosDaConta from '../settings/powerTools/SegredosDaConta.vue';
</script>

<template>
  <div class="flex-1 min-w-0 px-6 pt-4 pb-8 overflow-y-auto">
    <SegredosDaConta class="max-w-6xl" com-titulo />
  </div>
</template>
